import { render } from "./LoginScreen.vue?vue&type=template&id=7ca1ea28&ts=true"
import script from "./LoginScreen.vue?vue&type=script&lang=ts"
export * from "./LoginScreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__